export * from './IconFunnelRemove';
